import { cookie } from 'src/utils/cookie';
import { storage } from 'src/utils/localStorage';

class AuthService {
  static TOKEN_KEY = 'token';
  static USER_KEY = 'user';

  static setAuth(data) {
    if (!data) return;

    const { token, user } = data;

    if (token) {
      storage.set(this.TOKEN_KEY, token);
      // Set token cookie with domain for cross-subdomain access
      cookie.setWithDomain(this.TOKEN_KEY, token, {
        expire: 7 * 24 * 3600, // 7 days
        sameSite: 'Lax'
      });
    }

    if (user) {
      storage.set(this.USER_KEY, user);
      // Set user cookie with domain for cross-subdomain access
      cookie.setWithDomain(this.USER_KEY, JSON.stringify(user), {
        expire: 7 * 24 * 3600, // 7 days
        sameSite: 'Lax'
      });
    }
  }

  static getAuth() {
    try {
      const token = storage.get(this.TOKEN_KEY);
      const user = storage.get(this.USER_KEY);

      return {
        token,
        user,
        isAuthenticated: !!(token && user)
      };
    } catch (error) {
      console.error('Error getting auth:', error);
      return {
        token: null,
        user: null,
        isAuthenticated: false
      };
    }
  }

  static clearAuth() {
    console.log('🔐 Clearing authentication...');
    console.log('   📍 Current hostname:', typeof window !== 'undefined' ? window.location.hostname : 'SSR');
    console.log('   🍪 Cookies before clear:', typeof window !== 'undefined' ? document.cookie : 'N/A');

    // Remove cookies from all domains (including subdomains)
    cookie.eraseAll('root');
    console.log('   ✅ Removed "root" cookie from all domains');

    cookie.eraseAll(this.TOKEN_KEY);
    console.log(`   ✅ Removed "${this.TOKEN_KEY}" cookie from all domains`);

    cookie.eraseAll(this.USER_KEY);
    console.log(`   ✅ Removed "${this.USER_KEY}" cookie from all domains`);

    // Remove from localStorage (including persist:root for consistency with Next.js apps)
    storage.remove(this.TOKEN_KEY);
    console.log(`   ✅ Removed "${this.TOKEN_KEY}" from localStorage`);

    storage.remove(this.USER_KEY);
    console.log(`   ✅ Removed "${this.USER_KEY}" from localStorage`);

    storage.remove('persist:root');
    console.log('   ✅ Removed "persist:root" from localStorage');

    console.log('   🍪 Cookies after clear:', typeof window !== 'undefined' ? document.cookie : 'N/A');
    console.log('✅ Authentication cleared successfully');
  }

  static validateAuth() {
    console.log('🔍 Validating authentication state...');

    // Check if auth cookies exist
    const hasValidCookies = cookie.hasValidAuthCookies();

    if (!hasValidCookies) {
      console.log('⚠️  Auth cookies missing or expired. Clearing auth data...');
      this.clearAuth();
      return false;
    }

    console.log('✅ Auth cookies are valid');
    return true;
  }

  static isAuthenticated() {
    const { isAuthenticated } = this.getAuth();
    return isAuthenticated;
  }
}

export default AuthService;
